import { createClient } from "@supabase/supabase-js";
import { env } from "@/shared/config/env";
import type { Database } from "@/shared/types/database.types";

/**
 * Cliente único do Supabase para toda a aplicação.
 *
 * REGRA DE ARQUITETURA (obrigatória):
 * Nenhum componente ou página pode importar este arquivo diretamente.
 * Todo acesso a dados deve passar pela camada `src/services/*`.
 *
 * Pages → Components → Hooks → Services → supabaseClient → Supabase
 */
export const supabase = createClient<Database>(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY);
